var exports = {
  "ed": "PurchaseDisclaimer.module__disclaimer___Ym42X1",
  "gX": "PurchaseDisclaimer.module__center___Ym42X1",
  "kb": "PurchaseDisclaimer.module__left___Ym42X1",
};

module.exports = exports;
